import "core-js/modules/es.array.push.js";
import { defineComponent, onMounted, inject, ref, reactive, watch, nextTick } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import permission from "@/util/permission";
import cookies from "js-cookie";
import util from "@/util/util";
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import { UserOutlined } from "@ant-design/icons-vue";
import { useI18n } from "vue-i18n";
export default defineComponent({
  components: {
    UserOutlined
  },
  setup() {
    const {
      t,
      locale
    } = useI18n(); // 获取 locale 引用
    const changeLanguage = () => {
      locale.value = locale.value === "zh" ? "en" : "zh";
      localStorage.setItem("app-locale", locale.value); // 保存用户选择的语言
    };

    const activeName = ref("1");
    //更新信息
    const updateMsg = reactive([{
      'vision': '3.1.1',
      'text': ['新增点位信息管理板块，支持全量点位数据的快速检索与详情查阅', '活动详情页的文件上传功能现已支持追加模式，避免文件漏传需重复操作的问题', '优化部分页面整体布局与样式，提升系统易用性与视觉体验。', '针对多个使用场景进行交互体验优化，提升操作流畅度。', '屏幕管理导出新增故障原因。', '修复若干已知问题，进一步提升系统稳定性与可靠性。'],
      'data': "2026.05.18"
    }, {
      'vision': '3.0.1',
      'text': ['全面优化首页加载性能，显著提升系统访问速度与响应效率。', '新增屏幕管理数据导入与导出功能，提升批量维护与管理效率。', '新增供应商安装报告导出功能，支持快速生成与留存安装数据。', '新增多维度报表统计功能，便于业务数据分析与决策支持。', '统一并优化系统图标样式，提升整体视觉一致性与识别度。', '完善屏幕管理相关功能，增强设备管理的完整性与可操作性。', '新增屏幕点位管理相关功能，支持更精细化的点位维护。', '新增视频任务发布功能，提升内容投放与任务管理效率。'],
      'data': "2026.02.12"
    }, {
      'vision': '2.0.1',
      'text': ['新增供应商安装报告导出功能，支持快速生成与留存安装数据。', '新增报表统计功能，支持业务数据的集中展示与分析。', '下载模板中新增店铺类型字段，支持按店铺类型进行筛选。', '新增批量标记“已送达”功能，提升物流操作效率。', '统一分页规格为 25 / 50 / 200 条，提升数据浏览体验。', '物流列表新增上传记录展示，便于追踪数据变更。', '安装页面中，已验收店铺自动排序至列表底部。', '姓名展示规则优化，统一按照中文姓名格式显示。', '上传图片自动进行缩放处理，提升上传效率并节省存储空间。', '安装进度页面新增导出功能，支持数据快速导出。', '相关流程完成后自动向负责人发送邮件通知。', '活动进度页面在品牌方视角下进行 UI 优化调整。', '品牌方视角下隐藏 Step 操作流程，仅供应商可见。', 'Step 流程完成后新增状态提示，提升流程可感知性。', '系统各页面统一新增返回按钮，提升操作便捷性。', '活动总进度中仅展示参与活动的供应商，过滤无关数据。', '上传表格新增覆盖上传能力，避免重复数据冲突。', '移除子账号权限管理功能，简化账号管理逻辑。', '修复模板下载后表格字段顺序错乱的问题。', '修复模板下载后时间格式不一致的问题。', '供应商一键审核不通过后，支持重新拍照且无需店员再次审核。', '模板下载后新增筛选功能，提升数据筛选效率。', '导出数据时，点位信息按店铺顺序进行排序。', '修复物流数据展示不准确的问题。', '物流表模板导出时支持自动生成数据，减少人工错误。', '限制上传非已认领店铺的物流信息，确保数据准确性。', '新增图片多选上传功能，提升图片上传效率。', '点位照片中新增活动名称信息展示。', '预约数量统计口径调整为以店铺数量为准。', '预约同步功能调整为手动触发按钮形式。', '修复密码包含特殊字符时导致校验异常的问题。', '负责人部门结构支持多级层级展示。', '注册账号昵称规则调整为真实姓名展示。', '优化系统浅灰色配色方案，提升整体视觉一致性。', '账号登录方式调整为仅支持邮箱登录。', '预约同步规则优化：同一店铺以最先上传的预约时间为准。'],
      'data': "2025.06.05"
    }, {
      'vision': '1.0.1',
      'text': ['登录后新增用户头像与个人昵称展示，提升账号识别度。', '已结束活动支持进入查看，但不可进行编辑操作。', '限制供应商删除品牌方上传的文件，保障数据安全。', '修复表格下载后文件名出现乱码的问题。', '活动详情页面新增备注信息展示。', '上传活动封面时新增图片裁剪功能。', '修复子账号权限配置异常的问题。', '优化活动页面店铺清单的字体样式与显示效果。', '活动详情页面新增 Tab 分栏，包含「基本信息」与「门头照片」。', '活动 Excel 上传完成后自动刷新数据列表。', '修复主账号无法对部分子账号进行审批的问题。', '移除子账号权限管理功能，简化账号管理流程。', '注册账号时新增密码长度限制校验。', '合并安装预约模板与店铺、点位空模板数据结构，减少重复维护。', '安装预约截止时间调整为活动开始前 7 天。', '新增上传文件清单失败提示，提升异常反馈的明确性。', '限制供应商仅可生成自身所属供应商的施工码。', '新增验收完成页面，用于集中展示验收结果。', '下载文件名称规则优化，统一为「名称 + 时间」格式。', '限制供应商仅可签收自身供应商的专车快递。', '完善发货进度搜索功能，提升查询效率。', '供应商端感叹号图标支持自定义展示信息。', '修复供应商无法新增的问题。', '限制供应商仅可查看与自身相关活动的店铺数据。', '支持供应商在活动点位认领时配置多个负责人手机号。', '活动详情中，供应商负责店铺的服务数量统计口径统一为门店数量。', '店铺管理中点位照片默认展示最近一次活动的最新数据，支持一对多关系。', '店铺审核流程优化：供应商审核照片后品牌方方可查看。', '新增点位照片 Gallery 浏览模式。', '新增安装预约数据同步功能。', '活动详情页面新增物流信息上传功能。', '修复数据统计结果不准确的问题。', '修复签名时手机横竖屏切换导致样式错乱的问题。', '店铺管理模块新增导出功能，支持导出全部点位信息。', '新增验收单拍照功能，完善验收流程。'],
      'data': "2023.02.22"
    }]);
    activeName.value = updateMsg[0].vision;
    const router = useRouter();
    const store = useStore();
    const userInfoData = util.getUserInfo();
    const dialogVisible = ref(false);
    const globalUser = inject("globalUser");
    const stompClient = ref(null);
    const buttonShow = ref(true);
    const route = useRoute();
    const currentPath = ref(route.path);
    if (userInfoData != null) {
      globalUser.avatar = userInfoData.avatar;
      globalUser.email = userInfoData.email;
      globalUser.firstName = userInfoData.firstName;
      globalUser.id = userInfoData.id;
      globalUser.lastName = userInfoData.lastName;
      globalUser.managerId = userInfoData.managerId;
      globalUser.type = userInfoData.type;
    }
    const pathToMenus = [{
      url: "activity-browser",
      key: "1"
    }, {
      url: "list-interaction",
      key: "2"
    }, {
      url: "report-interaction",
      key: "2"
    }, {
      url: "create-interaction",
      key: "2"
    }, {
      url: "test-interaction",
      key: "2"
    }, {
      url: "repair-manage",
      key: "4"
    }, {
      url: "store-manage",
      key: "5"
    }, {
      url: "user-manage",
      key: "6"
    }, {
      url: "activity-report",
      key: "7"
    }, {
      url: "data-information",
      key: "8"
    }];
    const state = reactive({
      collapsed: false,
      selectedKeys: ["1"],
      openKeys: ["sub1"],
      preOpenKeys: ["sub1"]
    });
    let menuUrl = pathToMenus.find(menu => currentPath.value.includes(menu.url)) || null;
    if (menuUrl != null) {
      state.selectedKeys[0] = menuUrl.key;
    }
    const barCommand = key => {
      console.log(111111, key.key);
      if (key.key == "logout") {
        sessionStorage.removeItem("token");
        cookies.remove("token");
        router.replace("/");
      }
      if (key.key == "modify") {
        router.push("/user-modify");
      }
    };
    const goBack = () => {
      if (route.query.isScreen) {
        router.push({
          path: "/screen-manage",
          query: {
            isScreen: 2
          }
        });
      } else {
        router.go(-1);
      }
    };
    const handleClick = (tab, event) => {
      console.log(tab, event);
    };
    const getToday = async () => {
      const d = new Date();
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    onMounted(async () => {
      // const today = await getToday();
      // console.log('today')
      // console.log(today)
      // const lastShowDate = localStorage.getItem('updateModalLastDate');

      // if (lastShowDate !== JSON.stringify(today)) {
      //   dialogVisible.value = true;
      // }
      let visionId = localStorage.getItem('visionId');
      console.log(visionId);
      if (visionId == null || visionId !== activeName.value) {
        localStorage.setItem('visionId', activeName.value);
        dialogVisible.value = true;
      }
      var menuButton = document.getElementById("menu-button");
      var sidebar = document.getElementById("left-sidebar");
      var menubar = document.getElementById("left-menubar");
      menuButton.addEventListener("click", function () {
        sidebar.classList.toggle("sidebar-hidden");
      });
      sidebar.addEventListener("click", function () {
        sidebar.classList.toggle("sidebar-hidden");
      });
      menubar.addEventListener("click", function (event) {
        event.stopPropagation(); // 阻止事件冒泡
      });

      connect();
    });
    const menuSelect = (index, indexPath) => {
      switch (index.key) {
        case "1":
          router.push("/activity-browser");
          break;
        case "2":
          router.push("/list-interaction");
          break;
        case "3":
          router.push("/screen-manage");
          break;
        case "4":
          router.push("/repair-manage");
          break;
        case "5":
          router.push("/store-manage");
          break;
        case "6":
          router.push("/user-manage");
          break;
        case "7":
          router.push("/activity-report");
          break;
        case "8":
          router.push("/data-information");
          break;
      }
      console.log(index, indexPath);
    };
    const connect = () => {
      let tokenJson = util.getToken();
      const socket = new SockJS("/api/ws?token=" + tokenJson.access_token);
      stompClient.value = Stomp.over(socket);
      var headers = {
        Authorization: "Bearer " + tokenJson.access_token
      };
      stompClient.value.connect(headers, frame => {
        console.log("Connected: " + frame);
        stompClient.value.subscribe("/user/queue/messages", message => {
          console.log(message.body);
          // 这里处理接收到的消息
          // console.log(JSON.parse(message.body).content);
        });
      });
    };

    const updateOk = async () => {
      activeName.value = updateMsg[0].vision;
      localStorage.setItem('visionId', activeName.value);
      dialogVisible.value = false;
      // const today = await getToday();
      // localStorage.setItem('updateModalLastDate', JSON.stringify(today));
      // dialogVisible.value = false;
    };

    // const sendMessage = () => {
    //   stompClient.value.send("/api/app/message", {}, JSON.stringify(message));
    // };
    // 监听路由变化
    watch(route, newRoute => {
      if (newRoute.fullPath === "/list-interaction" || newRoute.fullPath === "/activity-browser" || newRoute.fullPath === "/screen-manage") {
        buttonShow.value = false;
      } else {
        buttonShow.value = true;
      }
    }, {
      immediate: true
    });
    return {
      menuSelect,
      permission,
      barCommand,
      store,
      goBack,
      globalUser,
      dialogVisible,
      handleClick,
      activeName,
      //2.0
      state,
      buttonShow,
      changeLanguage,
      updateMsg,
      updateOk
    };
  }
});